import {React, useContext} from 'react'
import { Link } from 'react-router-dom'
import news_example_1 from './static/img/news_example_1.jpg'
import BreadcrumbsSection from './BreadcrumbsSection'
import RoutesContext from '../contexts/RoutesContext'

function SingleNewsPage(props) {
    let routes_context = useContext(RoutesContext)
  return (
    <main>
        <BreadcrumbsSection routes={routes_context.routes} page_name="News and Articles" />
        
        <div className="single_news_top_container">
            <div className="single_news_inner_wrapper breadcrumbs_inner_wrapper">
                <div className="news_content_section">
                    <div className="single_news_title"><h1 className="">Türkmenistanda ekologiýa ýagdaýlar kämilleşdirilýär</h1></div>
                    <div className="single_news_date"><span className="">09.12.2021</span></div>
                    <div className="single_news_image"><img src={news_example_1} alt="" /></div>
                    <div className="single_news_description">
                        <p>
                            Türkmenistanyň Oba hojalyk we daşky gurşawy goramak ministrligi we BMG-niň ÖM bilen bilelikde guramagynda «Türkmenistanda durnukly şäherler: Aşgabatda we Awazada ýaşyl şäherleriň toplumlaýyn ösüşi» taslamasynyň çäklerinde ministrligiň Ekologiýa gözegçiligi gullugynyň himiýa barlaghanasynyň işgärleri üçin «Täze laboratoriýa enjamlaryny ulanmak we ekologiýa monitoringi hem-de gözegçiligi ulgamynyň mümkinçiligini güýçlendirmek» atly okuw seminary geçirildi.
                        </p>
                        <p>
                            BMG-niň ÖM-niň hünärmenleri seminara gatnaşanlar bilen Türkmenistanda ekologiýa monitoringiniň bar bolan ulgamynyň tehniki ugurlaryny ara alyp maslahatlaşdylar we tebigy gurşawyň zaýalanmagyna gözegçiligi amala aşyrmak üçin taslmany ýerine ýetirmegiň barşynda satyn alnan täze enjamy ulanmagyň ussullary bilen tanyşdylar.
                        </p>
                        <p>
                            BMG-niň ÖM-niň wekiliniň aýtmagyna görä, bu enjam Türkmenistanyň Oba hojalyk we daşky gurşawy goramak ministrliginiň ekologiýa laboratoriýalarynyň hünärmenleriniň işine ýardam bermek üçin alyndy. Täze enjamlary ulanmak daşky gurşawy goramak üçin netijeli ekologiýa monitoringini geçirmäge mümkinçilik berer. Enjamlaryň arasynda döwrebap abzallar we senagat kärhanalarynyň zyňyndylarynyň hem-de howany hapalaýan beýleki çeşmeleriň düzümindäki zyýanly maddalaryň ýagdaýyny kesgitlemegiň usullary bar.
                        </p>
                        <p>
                            Türkmenistan ekologýa ulgamynda halkara hzymatdaşlygyna ilatyň ýaşaýyş-durmuş derejesiniň has-da ýokarlanmagy üçin amatly şertler döretmäge gönükdirilen öz döwlet syýasatynyň möhüm ugry hökmünde garaýar. Durnukly şäherleriň ösdürilmegi, zyňyndy gazlaryň taşlanmagynyň we howanyň zaýlanmagynyň azaldylmagy, energiýa netijelilik we galyndylary durnukly dolandyrmak ýurdumyzyň ykdysady ösüşiniň uzak möhletleýin maksatlarydyr.
                        </p>
                    </div>
                </div>

                <div className="sidebar_section">
                    <div className="sidebar_section_inner_wrapper">
                        <h1 className="sidebar_section_title">Soňky täzelikler</h1>

                        <div className="news_item">
                            <Link to={routes_context.routes.single_news.path} className="news_item_title">Türkmenistanda ekologiýa ýagdaýlar kämilleşdirilýä...</Link>
                            <span className="news_item_date">09.12.2021</span>
                        </div>
                        <div className="news_item">
                            <Link to={routes_context.routes.single_news.path} className="news_item_title">Türkmenistanyň Kanuny «Ekologiýa howpsuzlygy hakyn...</Link>
                            <span className="news_item_date">23.11.2021</span>
                        </div>
                        <div className="news_item">
                            <Link to={routes_context.routes.single_news.path} className="news_item_title">Türkmenistanyň goraghanalary – bioköpdürlüligiň sa...</Link>
                            <span className="news_item_date">23.11.2021</span>
                        </div>
                        <div className="news_item">
                            <Link to={routes_context.routes.single_news.path} className="news_item_title">Plastmassanyň ýerine ekologiýa taýdan arassa we mo...</Link>
                            <span className="news_item_date">14.11.2021</span>
                        </div>
                        <div className="news_item">
                            <Link to={routes_context.routes.single_news.path} className="news_item_title">Milli Liderimiz ählihalk bag ekmek dabarasyna gatn...</Link>
                            <span className="news_item_date">07.11.2021</span>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        
    </main>
  )
}

export default SingleNewsPage